<template>
      <div class="roleEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'role', params: {} }">
          Role
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'roleEdit', params:{id: id} }">
            Edit Role
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Role</v-card-title>
          <v-card-text>
            <role-form :id="id"></role-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import RoleForm from './RoleForm.vue';

    export default {
      name: 'role',
      data () {
        return {
          id: null
        }
      },
      components: {
        RoleForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    